import React, { useEffect, useState } from "react";
import { XCircleIcon, PlusIcon } from "@heroicons/react/solid";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import { useSelector, connect } from "react-redux";
import { toast } from "react-toastify";

import {
  listGetAllTags,
  listAddUsersToTag,
  listAddCustomTag,
} from "../../../redux/actions/nrp/listActions";
import { Modal } from "../../components";
import { toAbsoluteUrl } from "../../../services";
import { FaCheck } from "react-icons/fa";

// get step data from redux main state
const data = (state) => state.nrpList;

const ListModal = (props) => {
  const [isNewLabel, setIsNewLabel] = useState(false);
  let { tagsList } = useSelector(data);
  const [allLabels, setAllLabels] = useState([]);
  const [selectedLabel, setSelectedLabel] = useState("");
  const [newLabel, setNewLabel] = useState("");

  let addNewTag = () => {
    if (newLabel) {
      props.listAddCustomTag(newLabel, props.campaign);
      setIsNewLabel(!isNewLabel);
      setNewLabel("");
      setTimeout(() => {
        props.listGetAllTags(props.campaign);
      }, 1000);
    } else {
      toast("label name required!", {
        position: "bottom-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  let getActiveTagData = (e) => {
    let activeTag = e.target.value;
    setSelectedLabel(activeTag);
  };

  let handelUsersTag = (tagObj) => {
    let { id } = tagObj;
    let { usersIds, campaign } = props;
    if (usersIds.length > 0) {
      props.listAddUsersToTag(usersIds, campaign, id);
      props.handelNo();
    } else {
      toast("No users found!", {
        position: "bottom-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  useEffect(() => {
    if (allLabels.length === 0 && newLabel.length === 0) {
      props.listGetAllTags(props.campaign);
    }
  }, []);
  useEffect(() => {
    if (tagsList) {
      setAllLabels(tagsList);
    }
  }, [tagsList]);

  return (
    <Modal
      classCustom="2xl:w-[20%] xl:w-[30%] lg:w-[30%] md:w-[50%] w-[50%]"
      open={props.listModal}
      onBackdropClick={props.onBackdropClick}
    >
      <div>
        <div className="bg-[#007E8C] px-2 py-3 flex flow-row items-center justify-between">
          <div className="flex items-center ">
            <img
              src={toAbsoluteUrl("/media/nrp/leaderboard/ListIcon.png")}
              alt="Export"
              style={{
                width: 15,
                height: 15,
                marginRight: 10,
              }}
            />
            <h3 className="text-[#FFFFFF] ml-2 font-semibold ">Lists</h3>
          </div>
          <XCircleIcon
            onClick={() => {
              setSelectedLabel("");
              props.handelNo();
            }}
            className="w-7 h-7 cursor-pointer "
            color="white"
          />
        </div>

        <div className="self-center">
          <div className="mx-2 py-4">
            {allLabels.length > 0 ? (
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={selectedLabel}
                onChange={getActiveTagData}
              >
                {allLabels &&
                  allLabels.map((item, i) => {
                    return (
                      <div key={i} className="flex  flex-col ">
                        <FormControlLabel
                          value={item.name}
                          control={
                            <Radio
                              checked={
                                selectedLabel === item.name ? true : false
                              }
                            />
                          }
                          label={
                            <div className="flex flex-row items-center">
                              <p className="mx-4">{item.name}</p>
                              {selectedLabel === item.name ? (
                                <FaCheck
                                  onClick={() => handelUsersTag(item)}
                                  className="w-5 h-6 ml-14 text-[#007E8C] cursor-pointer"
                                />
                              ) : null}
                            </div>
                          }
                        />
                      </div>
                    );
                  })}
              </RadioGroup>
            ) : (
              <p>No List Found</p>
            )}
          </div>
          <div className="mx-2 ">
            {isNewLabel ? (
              <div className="flex flow-row items-center">
                <div className="flex items-center">
                  <input
                    onChange={(e) => setNewLabel(e.target.value)}
                    className="ml-4 w-9/12 focus:outline-none focus:bg-white focus:border-gray-500"
                    placeholder="Add label"
                  />
                  <FaCheck
                    onClick={addNewTag}
                    className="w-5 h-6 text-[#007E8C] cursor-pointer"
                  />
                </div>
              </div>
            ) : null}
          </div>
          <div className="mx-2 py-4">
            <button
              onClick={() => setIsNewLabel(!isNewLabel)}
              className="flex flex-row items-center justify-center"
            >
              <PlusIcon
                className="w-5 h-5 cursor-pointer text-[#007E8C] "
                color="white"
              />
              Add Custom Label
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  listGetAllTags,
  listAddCustomTag,
  listAddUsersToTag,
})(ListModal);
